<div class="page-title-right">
  <ol class="breadcrumb m-0">
    <li class="breadcrumb-item"><a routerLink="/admin/bio">Bio</a></li>
    <li class="breadcrumb-item active">Links</li>
  </ol>
</div>

<div class="d-flex align-items-center justify-content-between mb-2">
  <h4 class="page-title mb-0">
    <i class="fas fa-link mr-2"></i>
    MeuCardapio Bio - Links
  </h4>
</div>

<!-- Loading -->
<div class="text-center p-5" *ngIf="carregando">
  <div class="k-i-loading" style="font-size: 40px;"></div>
</div>

<!-- Alerta sem bio page -->
<div class="card" *ngIf="!carregando && !idBioPagina">
  <div class="card-body text-center p-5">
    <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
    <p class="text-muted">Configure primeiro a pagina Bio em "Configuracoes" antes de adicionar links.</p>
    <a routerLink="/admin/bio/configuracoes" class="btn btn-primary">
      <i class="fas fa-cog mr-1"></i> Ir para Configuracoes
    </a>
  </div>
</div>

<!-- Layout com preview -->
<div class="bio-layout" *ngIf="!carregando && idBioPagina">
  <!-- Coluna esquerda: Conteudo -->
  <div class="form-panel">
    <div class="d-flex justify-content-end mb-3">
      <button class="btn btn-primary btn-add-link" (click)="novoLink()">
        <i class="fas fa-plus mr-1"></i> Adicionar Link
      </button>
    </div>

    <!-- Estado vazio -->
    <div class="card" *ngIf="links.length === 0">
      <div class="card-body text-center p-5">
        <i class="fas fa-link fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">Nenhum link cadastrado</h5>
        <p class="text-muted">Adicione links para WhatsApp, Instagram, cardapio e muito mais.</p>
        <button class="btn btn-primary" (click)="novoLink()">
          <i class="fas fa-plus mr-1"></i> Adicionar Primeiro Link
        </button>
      </div>
    </div>

    <!-- Lista de links com drag-and-drop -->
    <div *ngIf="links.length > 0">
      <div cdkDropList (cdkDropListDropped)="onDrop($event)" [cdkDropListDisabled]="linkExpandido !== null" class="links-list">
        <div class="link-card card mb-2"
             *ngFor="let link of links; let i = index"
             [class.expandido]="linkExpandido === (link.id || link._tempId || i)"
             [class.nao-salvo]="!link.id"
             cdkDrag
             [cdkDragDisabled]="linkExpandido !== null">

          <!-- Estado compacto -->
          <div class="card-body d-flex align-items-center py-2 px-3"
               *ngIf="linkExpandido !== (link.id || link._tempId || i)"
               [style.borderLeft]="'4px solid ' + obtenhaCorDoTipo(link.tipo)">
            <!-- Drag handle -->
            <div class="drag-handle mr-3" cdkDragHandle>
              <i class="fas fa-grip-vertical text-muted"></i>
            </div>

            <!-- Info -->
            <div class="flex-grow-1" style="cursor: pointer;" (click)="editarLink(link, i)">
              <div class="d-flex align-items-center">
                <span class="link-tipo-label mr-2" [style.color]="obtenhaCorDoTipo(link.tipo)">
                  {{obtenhaLabelDoTipo(link.tipo)}}
                </span>
                <span class="badge badge-warning" *ngIf="!link.id">Nao salvo</span>
              </div>
              <strong class="d-block link-titulo">{{link.titulo}}</strong>
              <span class="link-subtitulo" *ngIf="link.subtitulo">{{link.subtitulo}}</span>
              <span class="badge-etiqueta" *ngIf="link.etiqueta"
                    [style.backgroundColor]="corPrimaria || '#E53935'"
                    [style.color]="'white'">
                <i class="fas fa-tag"></i>{{link.etiqueta}}
              </span>
              <small class="text-muted d-block text-truncate link-url">{{link.url}}</small>
            </div>

            <!-- Controles -->
            <div class="link-controls">
              <kendo-switch [(ngModel)]="link.ativo"
                            (valueChange)="toggleAtivoLink(link)">
              </kendo-switch>

              <button class="btn btn-link link-action-btn" (click)="editarLink(link, i)"
                      kendoTooltip title="Editar">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="btn btn-link link-action-btn text-danger" (click)="confirmarExclusao(link)"
                      kendoTooltip title="Excluir">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <!-- Estado expandido (edicao inline) -->
          <div class="card-body" *ngIf="linkExpandido === (link.id || link._tempId || i)">
            <div class="d-flex align-items-center mb-3">
              <div class="link-icon mr-3" [style.backgroundColor]="obtenhaCorDoTipo(link.tipo) + '15'"
                   [style.color]="obtenhaCorDoTipo(link.tipo)">
                <img *ngIf="obtenhaLogoDoTipo(link.tipo)" [src]="obtenhaLogoDoTipo(link.tipo)" class="link-tipo-logo" [alt]="obtenhaLabelDoTipo(link.tipo)" />
                <i *ngIf="!obtenhaLogoDoTipo(link.tipo)" [class]="obtenhaIconeDoTipo(link.tipo)"></i>
              </div>
              <span class="badge badge-tipo mr-2" [style.backgroundColor]="obtenhaCorDoTipo(link.tipo) + '20'"
                    [style.color]="obtenhaCorDoTipo(link.tipo)">
                {{obtenhaLabelDoTipo(link.tipo)}}
              </span>
              <span class="badge badge-warning" *ngIf="!link.id">Nao salvo</span>
              <div class="ml-auto">
                <kendo-switch [(ngModel)]="link.ativo"></kendo-switch>
              </div>
            </div>
            <div class="form-group mb-2">
              <label class="font-weight-bold">Titulo</label>
              <input class="form-control" [(ngModel)]="link.titulo" placeholder="Titulo do link">
            </div>
            <div class="form-group mb-2">
              <label class="font-weight-bold">URL</label>
              <input class="form-control" [(ngModel)]="link.url" [placeholder]="placeholderUrl(link.tipo)">
            </div>
            <div class="form-group mb-2">
              <label class="font-weight-bold">Subtitulo (opcional)</label>
              <input class="form-control" [(ngModel)]="link.subtitulo" placeholder="Ex: Entrega gratis acima de R$ 50">
            </div>
            <div class="form-group mb-2">
              <label class="font-weight-bold">Etiqueta / Badge (opcional)</label>
              <input class="form-control" [(ngModel)]="link.etiqueta" placeholder="Ex: Mais barato que no iFood!">
              <small class="text-muted">Texto que aparece em destaque acima do link</small>
            </div>
            <div class="alert alert-danger py-2 mt-2 mb-0" *ngIf="erroValidacaoLink">
              <i class="fas fa-exclamation-circle mr-1"></i> {{erroValidacaoLink}}
            </div>
            <div class="d-flex justify-content-between mt-3">
              <button class="btn btn-sm btn-outline-danger" (click)="confirmarExclusao(link)">
                <i class="fas fa-trash mr-1"></i> Excluir
              </button>
              <div>
                <button class="btn btn-sm btn-outline-secondary mr-2" (click)="cancelarEdicaoInline(link, i)">Cancelar</button>
                <button class="btn btn-sm btn-primary" (click)="salvarLinkInline(link, i)" [disabled]="salvando">
                  <i class="fas fa-save mr-1" *ngIf="!salvando"></i>
                  <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvando"></i>
                  {{salvando ? 'Salvando...' : 'Salvar'}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna direita: Preview -->
  <div class="preview-panel">
    <div class="preview-header mb-3 text-center">
      <span class="text-muted font-weight-bold">Preview</span>
    </div>

    <!-- Toggle Mobile/Desktop -->
    <div class="preview-toggle mb-3 text-center">
      <div class="btn-group">
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'mobile', 'btn-outline-primary': modoPreview !== 'mobile'}"
                (click)="modoPreview = 'mobile'">
          <i class="fas fa-mobile-alt mr-1"></i> Mobile
        </button>
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'desktop', 'btn-outline-primary': modoPreview !== 'desktop'}"
                (click)="modoPreview = 'desktop'">
          <i class="fas fa-desktop mr-1"></i> Desktop
        </button>
      </div>
    </div>

    <!-- Frame do celular -->
    <div class="phone-frame" [ngClass]="{'desktop-frame': modoPreview === 'desktop'}">
      <div class="phone-notch" *ngIf="modoPreview === 'mobile'"></div>
      <div class="phone-screen">
        <iframe *ngIf="urlPreview"
                [src]="urlPreview"
                class="preview-iframe"
                frameborder="0"
                scrolling="yes">
        </iframe>
        <div *ngIf="!urlPreview" class="no-preview">
          <i class="fas fa-eye-slash fa-2x text-muted mb-2"></i>
          <p class="text-muted">Configure o slug para visualizar o preview</p>
        </div>
      </div>
      <div class="phone-home-bar" *ngIf="modoPreview === 'mobile'"></div>
    </div>

    <div class="mt-3 text-center" *ngIf="urlPreview">
      <button class="btn btn-outline-secondary btn-sm mr-2" (click)="recarregarPreview()">
        <i class="fas fa-sync-alt mr-1"></i> Atualizar Preview
      </button>
      <button class="btn btn-outline-secondary btn-sm" (click)="abrirEmNovaAba()">
        <i class="fas fa-external-link-alt mr-1"></i> Abrir Pagina
      </button>
    </div>
  </div>
</div>

<!-- Dialog de selecao de plataformas -->
<kendo-dialog *ngIf="exibirDialogPlataformas"
              title="Adicionar Link"
              (close)="exibirDialogPlataformas = false"
              [width]="500">
  <p class="text-muted mb-3">Selecione as plataformas que deseja adicionar:</p>
  <div class="plataformas-grid">
    <div *ngFor="let tipo of tiposDeLink"
         class="plataforma-item"
         [class.selecionada]="plataformasSelecionadas.has(tipo.valor)"
         (click)="togglePlataforma(tipo.valor)">
      <div class="plataforma-icone" [style.color]="tipo.cor">
        <img *ngIf="tipo.logo" [src]="tipo.logo" class="plataforma-logo" [alt]="tipo.label" />
        <i *ngIf="!tipo.logo" [class]="tipo.icone"></i>
      </div>
      <span>{{tipo.label}}</span>
      <i class="fas fa-check-circle check-icon" *ngIf="plataformasSelecionadas.has(tipo.valor)"></i>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="exibirDialogPlataformas = false">Cancelar</button>
    <button kendoButton [primary]="true" (click)="confirmarPlataformas()" [disabled]="plataformasSelecionadas.size === 0">
      <i class="fas fa-plus mr-1"></i> Adicionar ({{plataformasSelecionadas.size}})
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- Dialog confirmar exclusao -->
<kendo-dialog *ngIf="modalDeletar"
              title="Confirmar exclusao"
              (close)="fecharModalDeletar('nao')"
              [minWidth]="250" [width]="400">
  <p class="text-center my-3">
    Deseja realmente excluir o link <strong>"{{linkApagar?.titulo}}"</strong>?
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="fecharModalDeletar('nao')">Cancelar</button>
    <button kendoButton (click)="fecharModalDeletar('sim')" [primary]="true" themeColor="error">
      <i class="fas fa-trash mr-1"></i> Excluir
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
